<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <!-- Back -->
        <CRow>
          <CCol lg="12">
            <div class="d-flex align-items-center justify-content-end mb-3">
              <a
                href="javascript:void(0)"
                @click="$router.go(-1)"
              ><CIcon
                name="cil-arrow-left"
                class="mr-2"
              />Voltar</a>
            </div>
          </CCol>
        </CRow>

        <!-- Title -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">
              {{ $route.params.id ? 'Editar Banner' : 'Cadastrar Banner' }}
            </h4>
            <div class="d-flex align-items-center">
              <div class="ml-2 d-flex align-items-center">
                <label class="mb-0">
                  <b>Status</b>
                </label>
                <CSwitch
                  type="checkbox"
                  color="success"
                  variant="3d"
                  class="mx-2"
                  v-bind="labelIcon"
                  :checked.sync="status"
                />
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Fields -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0 d-flex align-items-center">
              <CIcon
                name="cil-justify-center"
                class="mt-md-1 mr-2"
              />
              Informações
              <img
                v-if="languageFlag"
                :src="require(`@/assets/img/flags/${languageFlag}.svg`)"
                alt="Bandeira do idioma"
                class="flag ml-2 mt-sm-1"
              />
            </h5>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol lg="4">
                <div class="form-group">
                  <label for="">Idioma*</label>
                  <Multiselect
                    :value="languageOptions.find(option => option.value == languageSelected)"
                    :options="languageOptions"
                    label="label"
                    track-by="value"
                    placeholder="Idioma"
                    :required="true"
                    @select="(selected) => languageSelected = selected.value"
                  />
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="4">
                <CInput
                  v-model="title"
                  label="Título*"
                  placeholder="Título do banner"
                  :disabled="processing"
                  required
                />
              </CCol>

              <CCol lg="4">
                <CInput
                  v-model="link"
                  label="Link"
                  placeholder="https://www.exemplo.com.br"
                  :disabled="processing"
                  type="url"
                />
              </CCol>

              <CCol
                v-if="link"
                lg="4"
              >
                <div class="form-group">
                  <label for="">Abrir como*</label>

                  <Multiselect
                    :value="linkTargetOptions.find(option => option.value == linkTargetSelected)"
                    :options="linkTargetOptions"
                    label="label"
                    track-by="value"
                    placeholder="Status"
                    :disabled="processing"
                    :required="true"
                    @select="(selected) => linkTargetSelected = selected.value"
                  />
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="4">
                <div class="form-group">
                  <label for="">Tempo*</label>

                  <Multiselect
                    :value="hasExpirationTimeOptions.find(option => option.value == expirationTimeSelected)"
                    :options="hasExpirationTimeOptions"
                    label="label"
                    track-by="value"
                    placeholder="Tempo de expiração"
                    :disabled="processing"
                    :required="true"
                    @select="handleSelectedTime"
                  />
                </div>
              </CCol>

              <CCol lg="4">
                <label>Data de publicação*</label>
                <Datepicker
                  :value="periodOf.value"
                  :disabled="processing"
                  :required="true"
                  @selected="periodOfSelected"
                />
              </CCol>

              <CCol
                v-if="expirationTimeSelected == 'determined'"
                lg="4"
              >
                <label>Data de expiração*</label>
                <Datepicker
                  :value="periodUntil.value"
                  :disabled="processing"
                  :required="true"
                  :disabled-dates="periodUntil.disabledDates"
                  @selected="periodUntilSelected"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <CCard>
          <CCardHeader>
            <h5 class="mb-0">
              <CIcon
                name="cil-justify-center"
                class="mb-1 mr-2"
              />
              Imagens
            </h5>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol lg="12">
                <FileUploader
                  id="desktopUploader"
                  :uploader-info="desktopUploaderInfo"
                  :enable-multiple="false"
                  :enable-crop-on-uploader="false"
                  :enable-edit-on-api-table="false"
                  :max-files="1"
                  :accept-types="acceptTypes"
                  :extensions="extensions"
                  :medias="desktopMedias"
                  :height="670"
                  :width="1920"
                  uploader-type="banner"
                  :required="true"
                  :disabled="processing"
                />
              </CCol>
            </CRow>

            <CRow class="mt-5">
              <CCol lg="12">
                <FileUploader
                  id="mobileUploader"
                  :uploader-info="mobileUploaderInfo"
                  :enable-multiple="false"
                  :enable-crop-on-uploader="false"
                  :enable-edit-on-api-table="false"
                  :max-files="1"
                  :accept-types="acceptTypes"
                  :extensions="extensions"
                  :medias="mobileMedias"
                  :height="420"
                  :width="768"
                  uploader-type="banner"
                  :required="true"
                  :disabled="processing"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            href="javascript:void(0)"
            class="mr-3"
            @click="clearEdit"
          >Limpar alterações</a>
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import FileUploader from '@/components/ui/Fileuploader'
import Datepicker from '@/components/ui/Datepicker'
import Modal from '@/components/ui/Modal'
import Multiselect from '@/components/ui/Multiselect'
import CardLog from '@/components/ui/CardLog'

// Dependencies
import moment from 'moment'

// Services
import BannerService from '@/services/banner.service'

export default {
  metaInfo: {
    title: 'Banners',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_banners')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    FileUploader,
    Datepicker,
    Modal,
    Multiselect,
    CardLog
  },

  data() {
    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      status: true,
      periodOf: {
        value: moment().format('YYYY-MM-DD')
      },
      periodUntil: {
        value: moment().format('YYYY-MM-DD'),
        disabledDates: {
          from: '',
          to: ''
        }
      },
      link: null,
      title: null,
      linkTargetSelected: '_self',
      linkTargetOptions: [
        {
          value: '_blank',
          label: 'Nova janela'
        },
        {
          value: '_self',
          label: 'Mesma janela'
        }
      ],
      expirationTimeSelected: '',
      hasExpirationTimeOptions: [
        {
          value: 'indeterminate',
          label: 'Indeterminado'
        },
        {
          value: 'determined',
          label: 'Determinado'
        }
      ],
      languageSelected: '1',
      languageOptions: [
        {
          label: 'Português',
          value: '1'
        },
        {
          label: 'Inglês',
          value: '2'
        },
        {
          label: 'Espanhol',
          value: '3'
        }
      ],
      acceptTypes: 'image/png,image/jpeg',
      extensions: 'jpg,jpeg,png',
      desktopUploaderInfo: {
        label: 'Banner Desktop',
        recomendation: `O texto deve ficar em uma área centralizada com a largura de 1120px,
        <a class="text-primary" href="${process.env.BASE_URL}banner-desktop-example.jpg" download>veja o exemplo</a>`
      },
      mobileUploaderInfo: {
        label: 'Banner Mobile',
        recomendation: `O texto deve ficar em uma área centralizada com a largura de 612px.
        <a class="text-primary" href="${process.env.BASE_URL}banner-mobile-example.jpg" download>veja o exemplo</a>`
      },
      hasLinkOptions: [
        {
          value: '0',
          label: 'Não'
        },
        {
          value: '1',
          label: 'Sim'
        }
      ],
      loadedDesktopMedias: [],
      loadedMobileMedias: [],
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      bannerId: null,
      desktopMedias: [],
      mobileMedias: [],
      processing: false,
      new: true,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      }
    }
  },

  computed: {
    languageFlag() {
      const languageId = parseInt(this.languageSelected)

      if (languageId === 1) {
        return 'pt-br'
      } else if (languageId === 2) {
        return 'en'
      } else if (languageId === 3) {
        return 'es'
      } else {
        return null
      }
    }
  },

  created() {
    this.setBannerData()
  },

  methods: {
    async setBannerData() {
      if (this.$route.params.id) {
        const banner = await BannerService.getBanner(this.$route.params.id)

        if (banner.medias.length > 0 || banner.mediasMobile.length > 0) {
          this.bannerId = banner.id
          this.link = banner.anchor_url
          this.title = banner.heading
          this.status = banner.status === 1
          this.linkTargetSelected = banner.anchor_target
          this.languageSelected = banner.language_id
          this.desktopMedias = banner.medias
          this.mobileMedias = banner.mediasMobile
          this.new = false

          if (banner.end_at && banner.begin_at) {
            this.expirationTimeSelected = 'determined'
            this.periodUntil.value = banner.end_at
            this.periodOf.value = banner.begin_at
          } else {
            this.expirationTimeSelected = 'indeterminate'
            this.periodOf.value = banner.begin_at
          }

          this.log = {
            created_by: banner.created ? banner.created.name : 'Seed',
            created_at: moment(banner.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: banner.updated ? banner.updated.name : null,
            updated_at: moment(banner.updated_at).format('DD/MM/YYYY HH:mm')
          }

          this.handlePeriodUntil()
          this.$forceUpdate()
        }
      } else {
        this.expirationTimeSelected = 'indeterminate'
      }
    },

    async clearEdit() {
      await this.setBannerData()
    },

    handleSelectedTime(selected) {
      this.expirationTimeSelected = selected.value
      this.handlePeriodUntil()
    },

    handlePeriodUntil() {
      // Set disabled dates
      const periodOfDate = moment(this.periodOf.value).toDate()
      this.periodUntil.disabledDates.to = periodOfDate

      // Handle periof of bigger than periof until
      if (moment(this.periodOf.value).isAfter(this.periodUntil.value)) {
        this.periodUntil.value = periodOfDate
      }
    },

    periodOfSelected(date) {
      const dateFormatted = moment(date).toDate()

      this.periodOf.value = dateFormatted
      this.handlePeriodUntil()
    },

    periodUntilSelected(date) {
      this.periodUntil.value = moment(date).toDate()
    },

    async send() {
      this.processing = true

      if (!this.desktopMedias.length > 0 || !this.mobileMedias.length > 0) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Por favor preencha a imagem desktop e a imagem mobile',
          color: 'danger'
        }
        this.processing = false
      } else {
        let response
        let message

        const data = {
          heading: this.title,
          anchor_url: this.link,
          anchor_target: this.linkTargetSelected,
          display: 1,
          language_id: this.languageSelected,
          status: this.status,
          medias: this.desktopMedias.map((media) => media.id),
          medias_mobile: this.mobileMedias.map((media) => media.id)
        }
        if (this.expirationTimeSelected === 'determined') {
          data.begin_at = moment.utc(this.periodOf.value).format('YYYY-MM-DD')
          data.end_at = moment.utc(this.periodUntil.value).format('YYYY-MM-DD')
        } else {
          data.begin_at = moment.utc(this.periodOf.value).format('YYYY-MM-DD')
        }

        if (!this.new) {
          response = await BannerService.updateBanner(this.bannerId, data)
          message = 'O banner foi atualizado com sucesso!'
        } else {
          response = await BannerService.storeBanner(data)
          message = 'O banner foi cadastrado com sucesso!'
          this.new = false
        }

        this.processing = false

        if (response.status === 200) {
          this.modal = {
            show: true,
            title: 'Sucesso',
            message: message,
            color: 'success',
            redirect: true
          }

          setTimeout(() => {
            // this.$router.go(-1)
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else if (response.status === 400) {
          this.modal = {
            show: true,
            title: 'Erro',
            message: (response.data.messages && response.data.messages.length > 0 && response.data.messages[0].message) || response.data,
            color: 'danger'
          }
        } else {
          this.modal = {
            show: true,
            title: 'Erro',
            message: 'Ocorreu um erro interno, por favor tente novamente!',
            color: 'danger'
          }
        }
      }
    }
  }
}
</script>
